import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row full-width full-height grouper-body min-height" }

import { storeToRefs } from 'pinia';
  import GrouperBodyEmbedded from 'components/grouper-common/GrouperBodyEmbedded.vue';
  import GrouperBodyFullscreen from 'components/grouper-common/GrouperBodyFullscreen.vue';
  import {GrouperLayoutMode} from 'src/services/IodineGrouperService';
  import { useLayoutStore } from 'stores/layout-store';
  import GrouperHeader from 'components/grouper-common/GrouperHeader.vue';
  import GrouperInfo from 'components/grouper-common/GrouperInfo.vue';
  import { useGrouperStore } from 'stores/grouper-store';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperBody',
  setup(__props) {

  const { layoutMode }  = storeToRefs(useLayoutStore());
  const { dualGrouping } = storeToRefs(useGrouperStore());
  const grouperStore = useGrouperStore();
  const {drgDrawerState} = storeToRefs(grouperStore);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GrouperHeader),
    _createVNode(GrouperInfo, {
      enableDualGrouping: _unref(dualGrouping),
      showApr: _unref(drgDrawerState)
    }, null, 8, ["enableDualGrouping", "showApr"]),
    (_unref(layoutMode) === _unref(GrouperLayoutMode).consolidated)
      ? (_openBlock(), _createBlock(GrouperBodyEmbedded, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(layoutMode) === _unref(GrouperLayoutMode).fullScreen)
      ? (_openBlock(), _createBlock(GrouperBodyFullscreen, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})